/// <reference path="App.ts" />
namespace HA.Core.HTML.App {
    export class Menu extends App {
        public clear(): this {
            this.getMenus().clear();
            return this;
        }

        public addItem(data: any) {
            this.getMenus().addItem(data);
        }

        protected createSelf() {
            super.createSelf();
            this.addClass("qmenu");
            this.addToContainer(new TextField({class: "label", text: document.createTextNode("Menu")}));
            const data = toMap(this.getData());
            data.delete("element");
            const items = new MenuPane(data);
            this.addToContainer(items);
            this.addToData("items", items);
        }

        protected initialize(data: any): void {
            super.initialize(data);
        }

        private getMenus(): MenuPane {
            return this.get("items");
        }
    }
}
